import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route pathname changes.
 * Fixes the mobile bug where navigating to a new page keeps the previous
 * scroll offset (e.g. lands mid-page instead of at the top).
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset scroll on both html and body to cover browsers that use either.
    // Use "instant" so we jump immediately, bypassing any global
    // `scroll-behavior: smooth` set in the CSS (which would animate a long scroll).
    if (typeof window !== "undefined") {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      } catch (_) {
        window.scrollTo(0, 0);
      }
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
